import { render, staticRenderFns } from "./SlideButton.vue?vue&type=template&id=525fed1a&scoped=true&"
import script from "./SlideButton.vue?vue&type=script&lang=js&"
export * from "./SlideButton.vue?vue&type=script&lang=js&"
import style0 from "./SlideButton.vue?vue&type=style&index=0&id=525fed1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525fed1a",
  null
  
)

export default component.exports